﻿import { FC, HTMLAttributes } from 'react';

export const Card: FC<HTMLAttributes<HTMLDivElement>> = ({ children, className = '', style, ...props }) => (
  <div className={`cs-card ${className}`.trim()} style={{ padding: '1.5rem', ...style }} {...props}>
    {children}
  </div>
);

export const CardHeader: FC<HTMLAttributes<HTMLDivElement>> = ({ children, style, ...props }) => (
  <div style={{ marginBottom: '1rem', ...style }} {...props}>
    {children}
  </div>
);

export const CardTitle: FC<HTMLAttributes<HTMLHeadingElement>> = ({ children, style, ...props }) => (
  <h3 style={{ fontSize: '1.25rem', fontWeight: 700, color: 'var(--color-navy-dark)', ...style }} {...props}>
    {children}
  </h3>
);

export const CardDescription: FC<HTMLAttributes<HTMLParagraphElement>> = ({ children, style, ...props }) => (
  <p style={{ fontSize: '0.875rem', color: 'var(--color-text-muted)', marginTop: '0.25rem', ...style }} {...props}>
    {children}
  </p>
);

export const CardContent: FC<HTMLAttributes<HTMLDivElement>> = ({ children, style, ...props }) => (
  <div style={{ ...style }} {...props}>
    {children}
  </div>
);

export const CardFooter: FC<HTMLAttributes<HTMLDivElement>> = ({ children, style, ...props }) => (
  <div style={{ marginTop: '1.5rem', paddingTop: '1rem', borderTop: '1px solid var(--color-border-subtle)', ...style }} {...props}>
    {children}
  </div>
);

